/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */

// utils
import dynamic from 'next/dynamic';
import { isColorLight } from '../../../../../../utils/FunctionsGlobals';
import styles from './RecommendationPiecesProperties.module.css';
const ApartamentCard = dynamic(() => import('../../../../../../components/carousel/apartment/ApartamentCard'), { ssr: false });
const ApartamentCard1 = dynamic(() => import('../../../../../../components/carousel/apartment/ApartamentCard1'), { ssr: false });

const RecommendationPiecesProperties: React.FC<{
    propertiesRelatedActual: Array<any>;
    site: any;
    favorito: Array<number>;
    setFavorito: any;
    imoveisEmpreendimento: boolean;
    allViewProperties: any;
}> = ({ propertiesRelatedActual, site, favorito, setFavorito, imoveisEmpreendimento,allViewProperties }) => {
    const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const RenderTitle = () => {
        if(imoveisEmpreendimento){
            const variavel = `/imoveis/venda/-/-/${propertiesRelatedActual[0]?.empreendimento?.nome.replaceAll(" ","-").replaceAll("\n", '-')}/-`.replaceAll(' ','-').toLowerCase();
            return <a href={variavel} target="_blank" rel="noopener noreferrer" className={styles.title} style={{color: cor_font}}>IMÓVEIS NO EMPREENDIMENTO {String(propertiesRelatedActual[0]?.empreendimento?.nome).toUpperCase()}</a>;
        } else {
            return <p className={styles.title} style={{color: cor_font}}>IMÓVEIS RELACIONADOS</p>;
        }
    };

    const RenderSubtitle = () => {
        if(imoveisEmpreendimento){
            return (
                <p className={styles.title_caracters} style={{color: cor_font}}>
                    SELECIONAMOS ALGUNS IMÓVEIS NO EMPREENDIMENTO {String(propertiesRelatedActual[0]?.empreendimento?.nome).toUpperCase()}
                </p>
            );
        }
        return (
            <p className={styles.title_caracters} style={{color: cor_font}}>
                SELECIONAMOS MAIS ALGUNS
                <p className={styles.title_bold} style={{color: cor_font}}>
                    {' IMÓVEIS NO PERFIL PARA VOCÊ'}
                </p>
            </p>
        );
    };

    if (propertiesRelatedActual?.length > 0) {
        return (
            <div className={styles.container}>
                {site?.modelo_card == 2 || site?.modelo_card == 3 ?
                    <ApartamentCard1
                        slides={propertiesRelatedActual}
                        title="Imóveis Relacionados"
                        site={site}
                        favorito={favorito}
                        RenderTitle={RenderTitle}
                        RenderSubtitle={RenderSubtitle}
                        cores={null}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                    />
                    :
                    <ApartamentCard
                        slides={propertiesRelatedActual}
                        title="Imóveis Relacionados"
                        RenderTitle={RenderTitle}
                        RenderSubtitle={RenderSubtitle}
                        site={site}
                        favorito={favorito}
                        setFavorito={setFavorito}
                        allViewProperties={allViewProperties}
                    />}
            </div>
        );
    }
    return null;
};

export default RecommendationPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
